export const AUTH_DISABLED = import.meta.env.VITE_DISABLE_AUTH === "true";

// Manager Changes (/news) is hidden in the published build until a
// contributor-driven version exists (issue #002).
export const NEWS_ENABLED = !AUTH_DISABLED;

// Graphic/image generation (share designers, "Download image", "Generate
// graphic") is hidden in the published build. Plain link sharing stays.
export const IMAGE_SHARING_ENABLED = !AUTH_DISABLED;
